var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.acao_anexar)?[_c('az-file-upload',{ref:"upload",attrs:{"multiple":true,"arquivos":_vm.marcacao.arquivos,"parms":{ 
                model_type: ( _vm.parm_model ? _vm.parm_model : 'marcacao' ), 
                model_id: _vm.marcacao[_vm.parm_campo_id ? _vm.parm_campo_id : 'id_marcacao'] 
            }},on:{"refresh":function($event){return _vm.carregar_arquivos()}}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }